<div class="xperience-container">
  <div class="container">
    <h1 [@slideInUp]="slideInUp">Experience</h1>
    <div [@zoomIn]="zoomIn" class="xperience-flex">
      <div class="flex-item">
        <h2>Freelancing - Web$scripters</h2>
        <h3>Full Stack Devlopment</h3>
        <h4>Clinical Biochemist Assocication TamilNadu - CBAT</h4>
        <p>
          Worked with the laboratory association based in Chennai and developed a web applicaiton that eases the member
          registration process and enables the notificaiton of the events happening in the association, manages the
          members using admin dashboard
        </p>
        <div class="tech-flex">
          <img src="../../../assets/angular.png" class="tech-item" alt="" srcset="">
          <img src="../../../assets/nodejs.png" class="tech-item" alt="" srcset="">
          <img src="../../../assets/MongoDB.png" class="tech-item" alt="" srcset="">
        </div>
        <span class="tech-links">
          <a class="blog-half-width" href="https://cbatindia.org" mat-raised-button color="blog-color"> Go to Site!</a>
        </span>
      </div>
      <div class="flex-item">
        <h2>Internship - Glosys Technology Solutions Pvt Ltd</h2>
        <h3>Datascience Corporate Training</h3>
        <h4>Neural Network tools and Activation Functions</h4>
        <p>
          Developed a tool for building neural network, this tool contains popular activation,loss function for vision
          models
        </p>
        <div class="tech-flex">
          <img src="../../../assets/numpy.svg" class="tech-item" alt="" srcset="">
          <img src="../../../assets/python.svg" class="tech-item" alt="" srcset="">
        </div>
        <span class="tech-links">
          <a class="blog-half-width" href="https://github.com/NareshAtnPLUS/glosysnet" mat-raised-button
            color="blog-color"> Go to&nbsp; &lt;/Source Code&gt;</a>
        </span>
      </div>
      <div class="flex-item">
        <h2>Blogging</h2>
        <h3>State Management in Angular using NgRx v9</h3>
        <h4>Implementing Redux pattern or CQRS Principle in Angular</h4>
        <p>Predicting the state of the application is very important when it comes to scaling your application to larger
          extends where the numbers of backends and the complexity of your application increases</p>
        <div class="tech-flex">
          <img src="../../../assets/angular.png" class="tech-item" alt="" srcset="">
          <img src="../../../assets/ngrx.svg" class="tech-item" alt="" srcset="">
        </div>
        <span class="tech-links">
          <a class="blog-half-width"
            href="https://medium.com/@nareshkumaratnplus/state-management-in-angular-using-ngrx-v9-11cb3efd4d18"
            mat-raised-button color="blog-color"> Go to Blog!</a>
          <a class="blog-half-width" href="https://github.com/NareshAtnPLUS/todo-app" mat-raised-button
            color="blog-color"> Go to&nbsp; &lt;/Source Code&gt;</a>
        </span>
      </div>
    </div>
  </div>
